import { render, staticRenderFns } from "./FoodBeverage.vue?vue&type=template&id=608c484e&scoped=true"
import script from "./FoodBeverage.vue?vue&type=script&lang=js"
export * from "./FoodBeverage.vue?vue&type=script&lang=js"
import style0 from "./FoodBeverage.vue?vue&type=style&index=0&id=608c484e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c484e",
  null
  
)

export default component.exports